import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dpg-sub-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class DpgSubInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
